import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PropertyHeader({
  form,
  editMode,
  isHost,
  onChange,
  newImages,
  onAddImages,
  onRemoveExistingImage,
  onRemoveNewImage
}) {
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const navigate = useNavigate();
  const sliderRef = useRef(null);

  const images = [...form.images, ...newImages.map(img => URL.createObjectURL(img))];

  // Slide automat la fiecare 3 secunde
  useEffect(() => {
    if (images.length === 0) return;
    const interval = setInterval(() => {
      setSelectedImageIndex(prev => (prev === images.length - 1 ? 0 : prev + 1));
    }, 3000);

    return () => clearInterval(interval);
  }, [images]);

  const prevImage = () => {
    setSelectedImageIndex(prev => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const nextImage = () => {
    setSelectedImageIndex(prev => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const minRoomPrice = useMemo(() => {
    if (!form?.roomsPrice) return 0;

    const prices = Object.values(form.roomsPrice)
      .map(Number)
      .filter(p => p > 0);

    return prices.length ? Math.min(...prices) : 0;
  }, [form.roomsPrice]);


  if (!form) return null;

  return (
    <div style={{ marginBottom: '1.5rem', fontFamily: "'Roboto Condensed', sans-serif", color: '#000', background: 'transparent' }}>

      <div style={{ position: 'relative', marginBottom: '0.8rem', textAlign: 'center' }}>
        {/* Back Button */}
        <button
          onClick={() => navigate('/')}
          style={{
            position: 'absolute',
            left: 0,
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'none',
            border: 'none',
            color: '#dd4124',
            cursor: 'pointer',
            fontWeight: '700',
            fontSize: '1.5rem'
          }}
        >
          ⇐
        </button>

        {/* Titlu */}
        {editMode && isHost ? (
          <input
            name="title"
            value={form.title}
            onChange={onChange}
            style={{
              padding: '0.5rem 0.8rem',
              fontSize: '1.4rem',
              fontWeight: '500',
              border: '1px solid #ccc',
              borderRadius: '6px',
              width: '100%',
              textAlign: 'center'
            }}
          />
        ) : (
          <h1 style={{ margin: 0, fontSize: '1.6rem', fontWeight: '500', color: '#000', fontFamily: "'Roboto Condensed', sans-serif'" }}>
            {form.title}
          </h1>
        )}
      </div>


      {/* Slide mare */}
      <div style={{ position: 'relative', marginBottom: '0.8rem', overflow: 'hidden', borderRadius: '6px' }}>
        <div
          ref={sliderRef}
          style={{
            display: 'flex',
            transition: 'transform 0.5s ease-in-out',
            transform: `translateX(-${selectedImageIndex * 100}%)`
          }}
        >
          {images.map((img, i) => (
            <img
              key={i}
              src={img}
              alt={`property-${i}`}
              style={{ width: '100%', flexShrink: 0, height: '260px', objectFit: 'cover' }}
            />
          ))}
        </div>

        {/* Sageti fara fundal */}
        <button
          onClick={prevImage}
          style={{
            position: 'absolute',
            left: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'transparent',
            color: '#dd4124',
            border: 'none',
            fontSize: '2rem',
            cursor: 'pointer'
          }}
        >‹</button>
        <button
          onClick={nextImage}
          style={{
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'transparent',
            color: '#dd4124',
            border: 'none',
            fontSize: '2rem',
            cursor: 'pointer'
          }}
        >›</button>
      </div>

      {/* Miniaturi */}
      <div style={{ display: 'flex', gap: '0.5rem', overflowX: 'auto', padding: '0.5rem 0' }}>
        {images.slice(0, 25).map((img, i) => (
          <div key={i} style={{ position: 'relative', flex: '0 0 auto', cursor: 'pointer' }}>
            <img
              src={img}
              alt={`mini-${i}`}
              onClick={() => setSelectedImageIndex(i)}
              style={{
                width: '60px',
                height: '45px',
                objectFit: 'cover',
                borderRadius: '4px',
                border: selectedImageIndex === i ? '2px solid #00d77' : '1px solid #ccc'
              }}
            />
            {editMode && isHost && i < form.images.length && (
              <button
                onClick={() => onRemoveExistingImage(i)}
                style={{
                  position: 'absolute',
                  top: '-5px',
                  right: '-5px',
                  background: '#dd4124',
                  color: 'white',
                  border: 'none',
                  borderRadius: '50%',
                  width: '18px',
                  height: '18px',
                  fontSize: '12px',
                  cursor: 'pointer'
                }}
              >×</button>
            )}
            {editMode && isHost && i >= form.images.length && (
              <button
                onClick={() => onRemoveNewImage(i - form.images.length)}
                style={{
                  position: 'absolute',
                  top: '-5px',
                  right: '-5px',
                  background: '#dd4124',
                  color: 'white',
                  border: 'none',
                  borderRadius: '50%',
                  width: '18px',
                  height: '18px',
                  fontSize: '12px',
                  cursor: 'pointer'
                }}
              >×</button>
            )}
          </div>
        ))}
      </div>

      {/* Upload imagini */}
      {editMode && isHost && (
        <div style={{ marginBottom: '1rem' }}>
          <input type="file" multiple accept="image/*" onChange={onAddImages} />
          <div style={{ fontSize: '0.8rem', color: '#666', marginTop: '0.3rem' }}>
            {images.length} / 25 imagini
          </div>
        </div>
      )}

      <div style={{ textAlign: 'center' }}>
        {minRoomPrice > 0 ? (
          <>
            <span style={{ color: '#006d77', fontWeight: 600 }}>
              de la {minRoomPrice} RON / noapte
            </span>

            {form.discount > 0 && (
              <span style={{ color: '#dd4124', marginLeft: '0.5rem', fontWeight: 600 }}>
                -{form.discount}%
              </span>
            )}
          </>
        ) : (
          <span style={{ color: '#999' }}>Pret indisponibil</span>
        )}
      </div>

      {/* Descriere */}
      <div style={{ padding: '0 1rem' }}>
        <textarea
          name="description"
          value={form.description}
          onChange={onChange}
          disabled={!editMode || !isHost}
          placeholder="Descriere"
          style={{
            width: '100%',
            padding: '0.5rem',
            minHeight: '80px',
            borderRadius: '6px',
            border: '1px solid #ccc',
            fontFamily: "'Sora', sans-serif",
            fontSize: '0.8rem',
            color: '#000'
          }}
        />
        </div>
      </div >
      );
}
